import React from 'react'
const { createContext, useContext, useState } = require('react')

const ProductSearchContext = createContext()

export function ProductSearchContextProvider(props) {
  const { children } = props
  const [calculateAlgoliaHitPosition, setCalculateAlgoliaHitPosition] =
    useState({
      page: 0,
      queryID: '',
      hits: [],
    })

  return (
    <ProductSearchContext.Provider
      value={{
        calculateAlgoliaHitPosition,
        setCalculateAlgoliaHitPosition,
      }}>
      {children}
    </ProductSearchContext.Provider>
  )
}

export function useProductSearchContext() {
  const context = useContext(ProductSearchContext)
  if (context === undefined) {
    throw new Error(
      'useProductSearchContext must be used within a ProductSearchContextProvider'
    )
  }
  return context
}
